import type { LegalDocType } from './LegalModals';

interface FooterProps {
  onOpenLegal: (type: LegalDocType) => void;
}

export function Footer({ onOpenLegal }: FooterProps) {
  return (
    <footer className="relative z-10 w-full pt-16 pb-8 border-t border-white/5 bg-black">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        <p className="text-[10px] text-neutral-400 uppercase tracking-widest text-center md:text-left">
          © {new Date().getFullYear()} Emilia Ivanova Industries. All rights reserved.
        </p>
        <div className="flex gap-6 text-[10px] text-neutral-400 uppercase tracking-widest">
          <button onClick={() => onOpenLegal('impressum')} className="hover:text-white transition-colors md:cursor-none">Legal Notice</button>
          <button onClick={() => onOpenLegal('agb')} className="hover:text-white transition-colors md:cursor-none">Terms</button>
          <button onClick={() => onOpenLegal('datenschutz')} className="hover:text-white transition-colors md:cursor-none">Privacy</button>
        </div>
      </div>
    </footer>
  );
}
